import React from "react"
import Icon from "@ant-design/icons"

const FacebookSVG = () => (
  <svg
    width="12"
    height="21"
    viewBox="0 0 12 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.80859 11.375L10.3008 8.14062H7.17188V6.03125C7.17188 5.11719 7.59375 4.27344 9 4.27344H10.4414V1.49609C10.4414 1.49609 9.14062 1.25 7.91016 1.25C5.34375 1.25 3.65625 2.83203 3.65625 5.64453V8.14062H0.773438V11.375H3.65625V19.25H7.17188V11.375H9.80859Z"
      fill="#FF6900"
    />
  </svg>
)

const Facebook = props => <Icon component={FacebookSVG} {...props} />

export default Facebook;